<template>
  <v-dialog
    v-model="show"
    width="40vw"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        <v-row no-gutters>
          <v-col cols="12">
            <span>
              <span> Actualizar entrega </span>
              {{ orderToUpdate.deliveryOrders.length + 1 }}
              - OP {{ orderToUpdate.serial }}
            </span>
          </v-col>
          <v-col cols="12">
            <span class="text-subtitle-1">
              {{ orderToUpdate.client }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="loteForm" lazy-validation>
            <v-row no-gutters>
              <v-col cols="12">
                <v-switch
                  v-model="isUrgent"
                  label="Pedido de urgencia"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Fecha entrega"
                  dense
                  outlined
                  clearable
                  type="date"
                  v-model="deliveryDate"
                ></v-text-field>
              </v-col>
              <v-col cols="12" align="start">
                <v-btn color="primary" rounded @click="updateDelivery">
                  <v-icon> mdi-save </v-icon>
                  Guardar
                </v-btn>
              </v-col>
              <v-col cols="12" align="end">
                <v-btn
                  color="primary"
                  rounded
                  @click="(showProductAddModal = true), (showAdvice = false)"
                >
                  <v-icon> mdi-plus </v-icon>
                  Añadir producto
                </v-btn>
              </v-col>
              <v-col cols="12" align="start" v-if="showAdvice">
                <span class="decrease">No hay prodcutos en OP</span>
              </v-col>
              <v-col cols="12" class="mt-5">
                <v-card elevation="10" class="rounded-lg">
                  <v-card-text>
                    <v-data-table
                      fixed-header
                      height="300px"
                      :headers="headers"
                      :items="products"
                      :items-per-page="10"
                      no-data-text="No hay productos"
                      loading-text="Cargando productos..."
                    >
                      <template #[`item.type`]="{ item }">
                        <span v-if="item.type">
                          {{ item.type.name }} {{ item.type.value == 'NA'? `(${item.folio})` : undefined }}
                        </span>
                        <span v-else>-</span>
                      </template>
                      <template #[`item.line`]="{ item }">
                        <span v-if="item.moType && item.line">
                          <div v-if="item.moType == 'bacteria'">
                            <div
                              v-if="item.name == 'Streptomyces griseoviridis'"
                            >
                              AS
                            </div>
                            <div v-else>B{{ item.line }}</div>
                          </div>
                          <div v-if="item.moType == 'fungi'">
                            H{{ item.line }}
                          </div>
                        </span>
                        <span v-else>
                          <span v-if="item.line">
                            {{ item.line }}
                          </span>
                          <span v-else>-</span>
                        </span>
                      </template>
                      <template #[`item.presentation`]="{ item }">
                        <span v-if="item.productType != 'KIT'">{{
                          item.presentation.name
                        }}</span>
                        <span v-else>-</span>
                      </template>
                      <template #[`item.order`]="{ item }">
                        <v-row>
                          <v-col>
                            <v-icon
                              color="red"
                              @click="removeProduct(item)"
                              :class="{ 'loading-icon': isDeleting }"
                            >
                              mdi-delete
                            </v-icon>
                          </v-col>
                          <v-col>
                            <v-icon
                              color="primary"
                              @click="updateProduct(item)"
                            >
                              mdi-pencil
                            </v-icon>
                          </v-col>
                        </v-row>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cerrar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <ProductAddModal
      v-model="showProductAddModal"
      v-if="showProductAddModal"
      @addProduct="addProduct"
    />
    <ProductUpdateModal
      v-model="showProductUpdateModal"
      v-if="showProductUpdateModal"
      @updateProduct="updateProductList"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//components
import ProductAddModal from "@/components/dashboard/production-orders/modals/ProductAddModal.vue";
import ProductUpdateModal from "@/components/dashboard/production-orders/modals/ProductUpdateModal.vue";
export default {
  components: {
    ProductAddModal,
    ProductUpdateModal,
  },
  data: () => ({
    headers: [
      {
        text: "Nombre",
        align: "start",
        value: "name",
        sortable: false,
      },
      {
        text: "Tipo",
        align: "center",
        value: "type",
        sortable: false,
      },
      {
        text: "Linea",
        align: "center",
        value: "line",
        sortable: false,
      },
      {
        text: "Presentación",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "Piezas",
        align: "center",
        value: "qty",
        sortable: false,
      },
      { text: "Acciones", align: "center", value: "order", sortable: false },
    ],
    products: [],
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    showProductAddModal: false,
    showProductUpdateModal: false,
    showAdvice: false,
    deliveryDate: null,
    client: null,
    isDeleting: false,
    isUrgent: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("order", ["orderToUpdate", "deliveryToUpdate"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    this.client = this.orderToUpdate.client;
    if (this.deliveryToUpdate) {
      this.deliveryDate = this.deliveryToUpdate.deliveredDate;
      this.isUrgent =
        this.deliveryToUpdate.isUrgent != undefined
          ? this.deliveryToUpdate.isUrgent
          : false;
      let index = 0;
      for (let item of this.deliveryToUpdate.orderProducts) {
        this.products.push({
          id: index,
          name: item.name,
          identification: item.identification,
          productType: item.productType,
          qty: item.qty,
          type: item.type,
          line: item.line,
          presentation: item.presentation,
          moType: item.moType,
          folio: item.folio,
          _id: item._id,
        });
        index++;
      }
    }
  },
  methods: {
    ...mapActions("order", [
      "addDeliveryOrder",
      "updateDeliveryOrder",
      "deleteProduct",
    ]),
    ...mapMutations("order", [
      "SET_PRODUCT_SELECTED",
      "SET_DELIVERY_OP_TO_UPDATE",
    ]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.SET_DELIVERY_OP_TO_UPDATE(null);
      this.show = false;
    },
    async confirmation() {
      //emit fetch table
      if (this.$refs.loteForm.validate() && this.products.length > 0) {
        try {
          this.showAdvice = false;
          this.isLoading = true;
          let payload = {
            orderId: this.orderToUpdate._id,
            products: this.products,
            user: this.user,
            deliveryDate: this.deliveryDate,
          };

          let response = await this.addDeliveryOrder(payload);
          if (response) {
            this.$emit("update");
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al crear OP`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al crear OP`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      } else {
        if (this.products.length == 0) {
          this.showAdvice = true;
        }
      }
    },
    async updateDelivery() {
      // if (this.$refs.loteForm.validate() && this.products.length > 0) {
      try {
        this.showAdvice = false;
        this.isLoading = true;
        let payload = {
          deliveryId: this.deliveryToUpdate._id,
          // products: this.products,
          user: this.user,
          deliveryDate: this.deliveryDate,
          orderId: this.orderToUpdate._id,
          isUrgent: this.isUrgent,
        };

        let response = await this.updateDeliveryOrder(payload);
        if (response) {
          this.$emit("update");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Entrega actualizada !!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al actualizar entrega de OP`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al actualizar entrega de OP`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoading = false;
      // } else {
      //   if (this.products.length == 0) {
      //     this.showAdvice = true;
      //   }
      // }
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    addProduct(value) {
      console.log("ADD");
      let index = this.products.length;

      this.products.push({
        id: index,
        name: value.name,
        identification: value.identification,
        productType: value.productType,
        qty: value.qty,
        type: value.type,
        line: value.line,
        presentation: value.presentation,
        moType: value.moType,
        folio: value.folio,
        _id: value._id,
      });

      this.showProductAddModal = false;
      this.SET_ALERT_TYPE({
        visible: true,
        type: "success",
        text: "Producto añadido !!",
        timeout: 3500,
      });
      this.$emit("update");
    },
    async removeProduct(item) {
      try {
        this.isDeleting = true;
        let payload = {
          product: item,
          user: this.user._id,
          orderId: this.orderToUpdate._id,
          deliveryId: this.deliveryToUpdate._id,
        };
        let response = await this.deleteProduct(payload);
        if (!response) throw response;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Producto eliminado !!",
          timeout: 3500,
        });
        this.$emit("update");
        let index = this.products.indexOf(item);
        this.products.splice(index, 1);
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al actualizar entrega de OP`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isDeleting = false;
    },
    updateProduct(item) {
      console.log(item);
      this.SET_PRODUCT_SELECTED(item);
      // this.SET_DELIVERY_OP_TO_UPDATE(null);
      this.showProductUpdateModal = true;
    },
    updateProductList(item) {
      for (let index = 0; index < this.products.length; index++) {
        let element = this.products[index];
        if (element._id == item._id) {
          this.products[index].name = item.name;
          this.products[index].identification = item.identification;
          this.products[index].productType = item.productType;
          this.products[index].qty = item.qty;
          this.products[index].type = item.type;
          this.products[index].line = item.line;
          this.products[index].presentation = item.presentation;
          this.products[index].moType = item.moType;
          this.products[index].folio = item.folio;
          this.products[index]._id = item._id;
          break;
        }
      }
      this.SET_ALERT_TYPE({
        visible: true,
        type: "success",
        text: "Producto actualizado !!",
        timeout: 3500,
      });
      this.showProductUpdateModal = false;
      this.$emit("update");
    },
  },
  watch: {
    // showProductAddModal(value) {
    //   if (!value) {
    //     this.SET_PRODUCT_SELECTED(null);
    //   }
    // },
  },
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
.loading-icon:before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #04c105;
  border-top-color: rgba(170, 213, 170, 0.6);
  color: green;
  border-radius: 50%;
  animation: spin 1s infinite linear;
  margin-right: 5px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
